<template>
  <div>
   <div class="bb-expenses">
     <transition-group name="bb-flip-list" tag="div" class="bb-expenses-totals">
       <total-card v-for="total in totalsExpenses" :key='total.id'
                   v-if="total.tabs.includes(activeTab)"
                   class="bb-expenses-totals__card"
                   :title="total.title"
                   :icon="total.icon"
                   :sum="total.sum"
                   :info="total.info"
                   :colorSum="total.color"/>
     </transition-group>
     <div class="bb-expenses-header">
       <div class="bb-tabs">
         <div class="bb-tabs__item"
              @click="activeTab = 1"
              :class="{'bb-tabs__item_active' : activeTab === 1}">
           General Expenses
         </div>
         <div class="bb-tabs__item"
              @click="activeTab = 2"
              :class="{'bb-tabs__item_active' : activeTab === 2}">
           Cash Register
         </div>
         <div class="bb-tabs__item"
              @click="activeTab = 3"
              :class="{'bb-tabs__item_active' : activeTab === 3}">
           Payroll Accounting
         </div>
       </div>
       <div class="bb-expenses-right-menu">
         <FilterByDate :get-query="getRequest"/>
         <div class="bb-expenses-right-menu__export"/>
       </div>
     </div>
   </div>
    <div>
      <template v-if="activeTab === 1">
        <GeneralExpenses @setTotal="setTotal" @setQuery="setQuery"/>
      </template>
      <template v-else-if="activeTab === 2">
        <CacheRegister @setTotal="setTotal" @setQuery="setQuery" @setTotalBalance="setTotalBalance"/>
      </template>
      <template v-else-if="activeTab === 3">
        <Payroll @setTotal="setTotal" @setQuery="setQuery"/>
      </template>
    </div>
  </div>
</template>

<script>
import TotalCard from '@/components/Finance/InvoiceTable/TotalCard/TotalCard'
import CacheRegister from '@/components/Finance/Expenses/CacheRegister/CacheRegister'
import GeneralExpenses from '@/components/Finance/Expenses/GeneralExpenses/GeneralExpenses'
import Payroll from '@/components/Finance/Expenses/Payroll/Payroll'
import FilterByDate from '@/components/Main/FilterByDate/FilterByDate'

export default {
  name: 'FinanceExpenses',
  components: {
    TotalCard,
    CacheRegister,
    GeneralExpenses,
    Payroll,
    FilterByDate
  },
  data () {
    return {
      activeTab: 1,
      totalsExpenses: {
        totalBalance: {
          id: 1,
          title: 'BALANCE',
          icon: 'icon-coins',
          sum: 0,
          tabs: [2]
        },
        totalAmount: {
          id: 2,
          title: 'TOTAL EXPENSES',
          icon: 'icon-coins',
          sum: 0,
          tabs: [1, 2, 3]
        }
      },
      getRequest: false
    }
  },
  methods: {
    setQuery (data) {
      this.getRequest = data
    },
    setTotalBalance (balance) {
      this.totalsExpenses.totalBalance.sum = balance || 0
    },
    setTotal (total) {
      this.totalsExpenses.totalAmount.sum = total || 0
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-expenses {
    &-header {
      display: flex;
      justify-content: space-between;
    }

    &-totals {
      display: flex;
      align-items: center;

      &__card {
        max-width: 210px;
        min-width: 210px;
        margin-bottom: 15px;
        margin-right: 20px;
      }
    }

    &-right-menu {
      display: flex;
      justify-content: center;
      align-items: center;
      transition: .3s;

      &__export {
        margin-left: 10px;
        width: 42px;
        height: 42px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/Expenses/Expenses.vue